import { OneAppStore } from '../types/OneAppStore';

export const selectHeapAppId = (state: OneAppStore) =>
  state.getIn(['config', 'heapAppId']);
